import {isMobile} from "mobile-device-detect";
import Cookies from 'js-cookie';
import Nav from "./components/Nav";
import LazyLoad from "./components/LazyLoad";
import Buttons from "./components/Buttons";
import Loader from "./components/Loader";
import Parallax from "./components/Parallax";
import OnScrollAnim from "./components/OnScrollAnim";
import Slider from "./components/Slider";
import {FilterComponent} from "./components/FilterComponent";

$(document).ready(() => {
    if(Cookies.get("ga-disable-UA-164250086-1") === "true") {
        window["ga-disable-UA-164250086-1"] = true;
    }

    isMobile && document.addEventListener('touchstart', () => {}, true);

    let ctrl = new ScrollMagic.Controller();
    ctrl.enabled(false);

    new Loader(ctrl).init();

    let anim = new OnScrollAnim(ctrl);
    anim.init();

    let lazy = new LazyLoad();
    lazy.init();

    let nav = new Nav();
    nav.init();

    const filterComponent = new FilterComponent();
    filterComponent.init();

    new Buttons().init();

    new Parallax(ctrl).init();

    new Slider("featured-pages", {
        loop: true,
        pagination: {
            el: '.js-swiper-pagination-featured-articles',
            type: 'fraction',
            clickable: true,
            renderFraction: function (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' +
                  ' – ' +
                  '<span class="' + totalClass + '"></span>';
            }
        }
    }).init();

    let winWidth = 0;
    let resizeTo;
    $(window).resize(function () {
        clearTimeout(resizeTo);
        winWidth = window.innerWidth;

        resizeTo = setTimeout(() => {
            nav.update(winWidth);
            lazy.update(winWidth);
        }, 300);
    });
});



// WEBPACK FOOTER //
// ./static/js/index.js